import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUpDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M160 342L458 20C471 6 485 0 500 0C515 0 528 5 542 20L836 338C877 382 863 428 812 428H188C140 428 122 386 160 342ZM250 356H750L500 85ZM160 658L458 980C471 994 485 1000 500 1000C515 1000 528 995 542 980L836 662C877 618 863 572 812 572H188C140 572 122 614 160 658ZM250 644H750L500 915Z" })
});
export default SvgCaretUpDown;
